import { useQueryParams } from '@calendly/hooks'


import { Header } from './header'
import { MaxWorkflowBanner } from './max_workflow_banner'
import { EmptyTeamNoAccess, EmptyTeamWithAccess } from './team_user_empty_banner'
import {
  EmptyUserWorkflows,
  UserDisabledWorkflows
} from './user_empty_state_banner'
import { maxOwnerWorkflowExceeded } from './util'
import {
  Container
} from '../../../../styles/owner_list_item'
import { WorkflowList } from '../../../workflow_list'


const EmptyTeamBody = ({ owner }) => {
  const {
    can_manage_workflows: canManageWorkflows,
  } = owner

  if (!canManageWorkflows) {
    return <EmptyTeamNoAccess />
  }

  return <EmptyTeamWithAccess owner={owner} />
}

const EmptyUserBody = ({ owner }) => {
  const {
    can_use_workflows: canUseWorkflows,
  } = owner

  if (!canUseWorkflows) {
    return <UserDisabledWorkflows />
  }

  return <EmptyUserWorkflows owner={owner} />
}

const Body = ({ owner }) => {
  const { admin_managed: adminManaged } = useQueryParams()
  const {
    workflows: { collection },
    type
  } = owner

  if (adminManaged) {
    return (
      <WorkflowList
        owner={owner}
        workflows={collection}
        newWindow={false}
        adminManaged
      />
    )
  }

  const isEmpty = collection.length === 0

  if (isEmpty && type === 'page') {
    return <EmptyTeamBody owner={owner} />
  }

  if (isEmpty && type === 'user') {
    return <EmptyUserBody owner={owner} />
  }

  return (
    <WorkflowList
      owner={owner}
      workflows={collection}
      newWindow={false}
    />
  )
}

export const Item = ({ owner }) => (
  <>
    {
      maxOwnerWorkflowExceeded(owner) && <MaxWorkflowBanner />
    }
    <Container data-component="owner_list_item">
      <Header owner={owner} />
      <Body owner={owner} />
    </Container>
  </>
)
